export type RunnerAabb = {
  sMin: number;
  sMax: number;
  laneMin: number;
  laneMax: number;
};

export function runnerAabbFromCenter(
  centerS: number,
  centerLane: number,
  widthS: number,
  heightLane: number,
): RunnerAabb {
  const halfWidthS = widthS / 2;
  const halfHeightLane = heightLane / 2;
  return {
    sMin: centerS - halfWidthS,
    sMax: centerS + halfWidthS,
    laneMin: centerLane - halfHeightLane,
    laneMax: centerLane + halfHeightLane,
  };
}

export function runnerAabbIntersects(a: RunnerAabb, b: RunnerAabb): boolean {
  return a.sMin < b.sMax && a.sMax > b.sMin && a.laneMin < b.laneMax && a.laneMax > b.laneMin;
}
